import {useI18n} from '../../../../common/providers/I18nProvider';
import PasswordField from '../../common/components/PasswordField';
import SubmitButton from '../../common/components/SubmitButton';
import useReset from './useReset';
import Form from '../../common/components/Form';
import FormControl from '../../common/components/FormControl';

export default function Reset() {
	const {loading, formik, showPassword, toggleShowPassword, canNotSubmit} = useReset();
	const {i18n} = useI18n();

	return (
		<Form title='AUTH.RESET.TITLE' status={formik.status} handleSubmit={formik.handleSubmit}>
			<FormControl
				label='AUTH.RESET.FIELD.NEW.LABEL'
				isInvalid={formik.errors.newPassword !== undefined}
				error={formik.errors.newPassword}
			>
				<PasswordField
					fieldProps={formik.getFieldProps('newPassword')}
					showPassword={showPassword}
					toggleShowPassword={toggleShowPassword}
					error={formik.errors.newPassword !== undefined}
				/>
			</FormControl>

			<FormControl
				label='AUTH.RESET.FIELD.CONFIRM.LABEL'
				isInvalid={formik.errors.confirmPassword !== undefined}
				error={formik.errors.confirmPassword}
			>
				<PasswordField
					fieldProps={formik.getFieldProps('confirmPassword')}
					showPassword={showPassword}
					toggleShowPassword={toggleShowPassword}
					error={formik.errors.confirmPassword !== undefined}
				/>
			</FormControl>

			<SubmitButton canNotSubmit={canNotSubmit} loading={loading}>
				{i18n('AUTH.RESET.BUTTON.RESET')}
			</SubmitButton>
		</Form>
	);
}
